export const ROUTES = {
  FORM: 'review_form',
  PAGES: {
    ALL: 'reviews',
    BATTERY: 'reviews_hub_battery',
  },
}
